import { useContext, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import TableHeaders from "./TableHeaders";
import { handleUuid } from "../utils/utils";
import { useStyles } from "../Styles/styles";
import { withStyles } from "@material-ui/core/styles";
import { UserContext } from "../Contexts/UserContext";

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const StyledTableCell = withStyles(() => ({
  root: {
    borderRight: "2px solid #e3e2e2",
    textAlign: "center",
    padding: 0,
  },
}))(TableCell);

export default function PaginatedTable({
  headers = [],
  error,
  rowClickHandler,
  selectedIndex,
  loading,
  rows = [],
  paginatedQueryHandler,
  paginated = true,
  tableHeight,
  rowsPerPageProp = 10,
}) {
  const classes = useStyles();
  const { nightMode } = useContext(UserContext);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageProp);

  const handleChangePage = (event, newPage) => {
    paginatedQueryHandler(rowsPerPage, newPage);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
    paginatedQueryHandler(parseInt(event.target.value, 10), 1);
  };

  return error ? (
    error?.message || "There was an error"
  ) : loading ? (
    <div>Loading...</div>
  ) : (
    <TableContainer
      style={{ maxHeight: tableHeight ? tableHeight : "" }}
      className={classes.tableContainer}
      component={Paper}
    >
      <Table stickyHeader aria-label="custom pagination table">
        <TableHeaders headers={headers} sortable={false} />
        <TableBody>
          {rows.length > 0 ? (
            rows.map((row, index) => {
              return (
                <StyledTableRow
                  key={handleUuid()}
                  onClick={() => rowClickHandler && rowClickHandler(index)}
                  style={{
                    backgroundColor:
                      rowClickHandler && selectedIndex === index
                        ? "lightblue"
                        : index % 2 || nightMode
                        ? "inherit"
                        : "lightgrey",
                  }}
                >
                  {headers.map(head => {
                    const show = headers.find(
                      header => header.idName === head.idName
                    )?.show;
                    const color =
                      head.idName === "type"
                        ? row.callTypeColor
                        : head.idName === "location"
                        ? row.locationColor
                        : "inherit";

                    return (
                      <StyledTableCell
                        style={{
                          display: show === undefined || !!show ? "" : "none",
                          color,
                        }}
                        key={handleUuid()}
                        align={"left"}
                        component="th"
                        scope="row"
                      >
                        {typeof row[head.idName] === "string"
                          ? row[head.idName]?.split("|")?.map(value => {
                              return (
                                <p style={{ margin: 0 }} key={handleUuid()}>
                                  {value}
                                </p>
                              );
                            })
                          : row[head.idName]}
                      </StyledTableCell>
                    );
                  })}
                </StyledTableRow>
              );
            })
          ) : (
            <tr>
              <td>No results</td>
            </tr>
          )}
        </TableBody>
        {paginated && (
          <TableFooter>
            <StyledTableRow>
              <TablePagination
                rowsPerPageOptions={[10, 25, 50]}
                colSpan={headers?.filter(head => head.show).length}
                count={-1}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={(e, newPage) => {
                  if (newPage > 0) handleChangePage(e, newPage);
                }}
                backIconButtonProps={page === 1 ? { disabled: true } : {}}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelDisplayedRows={() =>
                  `${1 + rowsPerPage * (page - 1)} - ${rowsPerPage * page}`
                }
              />
            </StyledTableRow>
          </TableFooter>
        )}
      </Table>
    </TableContainer>
  );
}
